import { EpStore } from '../../services/store/ep-store';
import { AnyAction } from 'deox';
import {
  addToWallet, applicationComplete,
  applicationTimeout, cancelApplication,
  dspTimeout, FmcSdk, heightChanged, offerResponse,
  receiveApplicationResult, receivePrescreenApplicationResult,
  receiveAccountExists, submitApplication,
  viewPage, submitPrescreenApplication,
} from 'fmc-sdk';

/**
 * Create the sdk message callback and pass in a store so
 * it is easier to test.
 */
export const getSdkMessageCallback = (store: EpStore) => {
  return (action: AnyAction) => {
    /**
     * Only re-dispatch whitelisted events
     */
    switch (action.type) {
      case viewPage.type:
      case submitApplication.type:
      case applicationTimeout.type:
      case dspTimeout.type:
      case addToWallet.type:
      case receiveApplicationResult.type:
      case receivePrescreenApplicationResult.type:
      case receiveAccountExists.type:
      case heightChanged.type:
      case offerResponse.type:
      case applicationComplete.type:
      case cancelApplication.type:
      case submitPrescreenApplication.type:
        store.dispatch(action);
        break;
    }
  };
};

/**
 * Unsubscribe from all events in the embedded iframe.
 */
export const unsubscribeEmbeddedFrameEvents =
  (fmcSdkInstance: FmcSdk, sdkCallbackFnc: (action: AnyAction) => void) => {
    if (!fmcSdkInstance) return;

    fmcSdkInstance.offAny(sdkCallbackFnc);
  };

/**
 * Search the overlay for iframes and if one exists listen to it's events
 */
export const bindEmbeddedFrameEvents = (domTarget: HTMLElement,store: EpStore): {
    fmcSdkInstance: FmcSdk,
    sdkMessageCallback: (action: AnyAction) => void
  } => {
    const iframeNode = domTarget.querySelector('iframe');
    if (!iframeNode) return;

    const fmcSdkInstance = new FmcSdk({
      iframe: iframeNode // A HTMLIFrameElement reference that embeds the FMC application.
    });

    /**
     * Create callback here so it can be saved for later to unsubscribe
     */
    const sdkMessageCallback = getSdkMessageCallback(store);

    fmcSdkInstance.onAny(sdkMessageCallback);

    /**
     * Start receiving actions. Actions are queued until `init` is called.
     * This should be called _after_ setting up all action listeners to avoid
     * missing data.
     */
    fmcSdkInstance.init();

    return {
      sdkMessageCallback,
      fmcSdkInstance,
    };
  };
